import { View, TouchableOpacity } from 'react-native';
import React from 'react';
import { Controller, type Control } from 'react-hook-form';
import CheckSVG from '../../assets/img/check.svg';
import Text from '../Text';

interface Props {
  name: string;
  control: Control<any, any>;
  children: React.ReactNode;
  error?: string;
  className?: string;
}

const Checkbox = ({ name, control, children, className, error }: Props) => {
  return (
    <View className={`flex-row items-center ${className}`}>
      <Controller
        name={name}
        control={control}
        rules={{ required: true }}
        render={({ field: { value, onChange, ...fieldRest } }) => (
          <TouchableOpacity
            activeOpacity={0.6}
            hitSlop={{ top: 8, right: 8, bottom: 8, left: 8 }}
            {...fieldRest}
            onPress={() => {
              onChange(!value);
            }}
          >
            <View
              className={`w-5 h-5 border rounded border-gray-300 items-center justify-center mr-2 ${
                error ? 'border-feedback-error-main' : ''
              }`}
            >
              {value && <CheckSVG />}
            </View>
          </TouchableOpacity>
        )}
      />
      {typeof children === 'string' ? (
        <Text className="text-xs text-gray-600">{children}</Text>
      ) : (
        <View>{children}</View>
      )}
    </View>
  );
};

export default Checkbox;
